<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
      <div class="modal-header">Associer une consultation</div>
      <div class="modal-body" *ngIf="formGroup">
        <frg-form-input
          *ngIf="consultationsListValues && consultationsListValues.length > 0"
          label="Consultations"
          id="title"
          [selectValue]="consultationsListValues"
          type="ngSelect"
          [formGroup]="formGroup"
          [control]="formGroup.get('title')"
          [isClearableSelect]="false"
        ></frg-form-input>
        <span class="no-consultation" *ngIf="!consultationsListValues || consultationsListValues.length === 0">
          Aucune consultation
        </span>
      </div>
      <div class="button-wrapper">
        <frg-button backgroundColor="var(--darkest-primary)" (activated)="closeModal()">Annuler</frg-button>
        <frg-button (activated)="validForm()" [disabled]="!formGroup.valid">Valider</frg-button>
      </div>
    </div>
  </div>
  <div class="modal-background"></div>